import { render, staticRenderFns } from "./WarehouseCardHeader.vue?vue&type=template&id=28677188&"
import script from "./WarehouseCardHeader.vue?vue&type=script&lang=js&"
export * from "./WarehouseCardHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports